export default __webpack_public_path__ + "static/media/javascript.e5c417b3.svg";